import React from "react";
import RestaurantMenu from "pages/RestaurantMenu/RestaurantMenu";

const GuestMenuPage = ({ guestMode }) => (
  <RestaurantMenu embedded guestMode={guestMode} />
);

export default GuestMenuPage;
